var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAlarmCritical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_alarm_critical") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_alarm_critical",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    stroke: "#C60000",
    cx: 11,
    cy: 11,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    stroke: "#C60000",
    cx: 11,
    cy: 11,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,11 C5,14.314 7.686,17 11,17 C14.314,17 17,14.314 17,11 C17,7.686 14.314,5 11,5 C7.686,5 5,7.686 5,11 Z",
    id: "Clip-2",
    fill: "#C60000",
    fillRule: "nonzero",
    transform: "translate(11.000000, 11.000000) rotate(-180.000000) translate(-11.000000, -11.000000) "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmCritical);
export default __webpack_public_path__ + "static/media/icon_alarm_critical.d3c6322c5998537e017e45fc531e1922.svg";
export { ForwardRef as ReactComponent };